// Case-insensitive comparison for strings; strict otherwise
export function eq(a, b) {
    if (typeof a === "string" && typeof b === "string") {
        return a.trim().toLowerCase() === b.trim().toLowerCase();
    }
    return a === b;
}

// Does depAns "contain" expected?
// - arrays: includes
// - objects: selections[]; or .type; or any string value equals expected
// - primitives: eq
export function containsExpected(depAns, expected) {
    if (Array.isArray(depAns)) {
        return depAns.some((v) => eq(v, expected));
    }

    if (depAns && typeof depAns === "object") {
        // Common pattern: { selections: [...] }
        if (Array.isArray(depAns.selections)) {
            if (depAns.selections.some((v) => eq(v, expected))) return true;
        }
        // Payment pattern: { type: 'insurance', provider: 'Aetna' }
        if (typeof depAns.type === "string" && eq(depAns.type, expected)) return true;

        // Fallback: check any string field on the object
        for (const v of Object.values(depAns)) {
            if (typeof v === "string" && eq(v, expected)) return true;
            if (Array.isArray(v) && v.some((x) => typeof x === "string" && eq(x, expected))) {
                return true;
            }
        }
        return false;
    }

    return eq(depAns, expected);
}

// expected can be single value or array (OR semantics)
export function satisfiesExpected(depAns, expected) {
    if (Array.isArray(expected)) {
        return expected.some((e) => containsExpected(depAns, e));
    }
    return containsExpected(depAns, expected);
}
